export default "__VITE_ASSET__B45tLhZR__"